import { call, put, takeEvery } from 'redux-saga/effects';

import { authApi } from '../../api/client';
import { actions, types } from './authReducer';

function* checkSession() {
  try {
    const { data } = yield call(authApi.login);
    if (data && data.url) {
      // Not authenticated — redirect to Azure AD login
      window.location.href = data.url;
      return;
    }
    yield put(actions.checkSessionSuccess(data));
  } catch (err) {
    yield put(actions.checkSessionFailure(err.message));
  }
}

function* logout() {
  try {
    yield call(authApi.logout);
  } finally {
    window.location.reload();
  }
}

export default function* authSaga() {
  yield takeEvery(types.CHECK_SESSION_REQUEST, checkSession);
  yield takeEvery(types.LOGOUT, logout);
}
